import { Injectable } from '@angular/core';
import { Xnotif } from '@df/module-xnotif/xnotif.interfaces';
import { NgForm } from '@angular/forms';
import { IRequestCallback, RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';

@Injectable({
    providedIn: 'root'
})
export class XnotifService {
    /**
     * Class contructor
     */
    constructor(private requestService: RequestService) {}

    /**
     * Send submission
     */
    public submit(form: NgForm, status: Status | undefined, data: Xnotif.IData, onSuccess?: IRequestCallback) {
        return this.requestService.submitForm(
            form,
            status,
            {
                path: Xnotif.ENDPOINTS_SUBMIT,
                data
            },
            onSuccess
        );
    }
}
